import React from "react";
import { connect } from "react-redux";
import { Row, Col, Button, Affix, Form } from "antd";
import "./CustomerCard.css";
import { getCustomer, editCustomer } from "../../redux/actions/customers";
import { setCaption } from "../../../../common/redux/actions/interfaceActions";
import * as URLs from "../../../../common/constants/systemUrls";

import CustomerCardForm from "../../components/CustomerCard/CustomerCardForm";
import { FormProgress } from "../../components/FormProgress/FormProgress";

import progresses from "../../components/FormProgress/progresses";
import { dadataClearSelected } from "../../../Authorization/redux/actions/daData";
import {
  showConfirmAbortEdit,
  showConfirmSave
} from "../../components/common/modal/confirmModal/ConfirmModal";
import moment from "moment";

class CustomerCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
      formProgress: progresses.default,
      data: {}
    };
    this.formRef = null;
  }

  componentDidMount() {
    if (
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.id
    ) {
      this.props.getCustomer(this.props.match.params.id);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.state.editMode !== prevState.editMode ||
      this.props.customerData !== prevProps.customerData
    ) {
      this.props.setCaption({
        enabled: true,
        captionType: "crumbs",
        mainCaption: this.state.editMode
          ? "Редактирование заказчика"
          : this.props.customerData.subjectKey === "physical"
          ? `${this.props.customerData.lastname} ${
              this.props.customerData.name
            } ${this.props.customerData.patronymic || ""}`
          : this.props.customerData.nameLegal,
        breadCrumbs: [
          {
            path: "/" + URLs.CONTROL_PANEL,
            breadcrumbName: "Панель управления"
          },
          { path: "/" + URLs.CUSTOMERS, breadcrumbName: "Заказчики" },
          {
            breadcrumbName: this.state.editMode
              ? "Редактирование заказчика"
              : this.props.customerData.subjectKey === "physical"
              ? `${this.props.customerData.lastname} ${
                  this.props.customerData.name
                } ${this.props.customerData.patronymic || ""}`
              : this.props.customerData.nameLegal
          }
        ]
      });
    }

    if (this.props.updated && this.props.updated !== prevProps.updated) {
      this.setState({ editMode: false });
    }
  }

  handleFieldsChange = values => {
    this.setState(
      { ...this.state, data: { ...this.state.data, ...values } },
      () => {
        this.updateProgress(values);
      }
    );
  };

  updateProgress = values => {
    const form = this.formRef.props.form;
    if (form) {
      let newFormProgress = [...this.state.formProgress];
      Object.keys(values).forEach(name => {
        this.state.formProgress.forEach((step, index) => {
          if (step.fields.some(fieldName => fieldName === name) && step.check) {
            const fieldsValue = form.getFieldsValue(step.fields);
            const check = step.check(fieldsValue, form);

            newFormProgress[index] = {
              ...this.state.formProgress[index],
              name: step.name,
              completed: !!check,
              fieldsValue: fieldsValue
            };
          }
        });
      });

      if (newFormProgress) {
        this.setState({ formProgress: newFormProgress });
      }
    }
  };

  onSubjectKeyChange = e => {
    this.setState(
      {
        data: {
          ...this.state.data,
          subjectKey: { value: e.target.value },
          // При переключении subjectKey сбрасываем основные поля заказчика.
          nameLegal: { value: undefined },
          name: { value: undefined },
          lastname: { value: undefined },
          patronymic: { value: undefined },
          inn: { value: undefined },
          kpp: { value: undefined },
          ogrn: { value: undefined },
          dadataSearch: { value: undefined },
          registrationDate: { value: undefined },
          addressLegal: { value: undefined },
          birthDate: { value: undefined },
          birthPlace: { value: undefined },
          passportSeries: { value: undefined },
          passportNumber: { value: undefined },
          hasNoPatronymic: { value: undefined }
        }
      },
      () => {
        this.formRef.props.form.setFieldsValue({
          subjectKey: e.target.value,
          // При переключении subjectKey сбрасываем основные поля заказчика.
          nameLegal: undefined,
          name: undefined,
          lastname: undefined,
          patronymic: undefined,
          inn: undefined,
          kpp: undefined,
          ogrn: undefined,
          dadataSearch: undefined,
          registrationDate: undefined,
          addressLegal: undefined,
          birthDate: undefined,
          birthPlace: undefined,
          passportSeries: undefined,
          passportNumber: undefined,
          hasNoPatronymic: undefined
        });
      }
    );
  };

  initEditing = () => {
    if (!this.state.editMode) {
      let newEditData = {};
      const data = this.props.customerData;
      if (data) {
        Object.keys(data).forEach(item => {
          newEditData[item] = Form.createFormField({
            value: data[item]
          });
        });
      }
      this.setState(
        { data: newEditData, editMode: !this.state.editMode },
        () => {
          this.updateProgress(newEditData);
        }
      );
    } else {
      this.setState({ data: this.props.customerData, editMode: false });
    }
  };

  onSubmitForm = () => {
    this.formRef.props.form
      .validateFields((err, values) => {
        if (err) {
          throw new Error(err);
        }
        return values;
      })
      .then(values => {
        showConfirmSave({
          onOk: () => {
            this.props.editCustomer(values);
          }
        });
      })
      .catch(err => {
        console.error(err);
      });
  };

  toggleEditing = () => {
    this.initEditing();
  };

  getValueByFieldName(name, val) {
    if (name.includes("Date")) {
      return (val && moment(val)) || null;
    } else {
      return val;
    }
  }

  render() {
    const { dadataClearSelected, errors, clearAddCustomerErrors } = this.props;
    const disabled = !this.state.editMode;

    const data = disabled ? this.props.customerData : this.state.data;
    return (
      <div className="add-customer basicForm">
        <Row gutter={16}>
          <Col span={18} className="add-customer__form-wrapper">
            <CustomerCardForm
              wrappedComponentRef={inst => (this.formRef = inst)}
              handleFieldsChange={this.handleFieldsChange}
              updateProgress={this.updateProgress}
              dadataClearSelected={dadataClearSelected}
              onSubjectKeyChange={this.onSubjectKeyChange}
              data={data}
              disabled={disabled}
              errors={errors}
              clearAddCustomerErrors={clearAddCustomerErrors}
              getValueByFieldName={this.getValueByFieldName}
            />
          </Col>
          <Col span={6} className="add-customer__sidebar">
            <Affix
              offsetTop={18}
              target={() => document.getElementById("mainSheet")}
            >
              <div className="add-customer__button-wrap">
                <Button
                  type="primary"
                  htmlType="button"
                  size="large"
                  className="add-customer__submit"
                  style={{ width: "100%" }}
                  onClick={() => {
                    if (!this.state.editMode) {
                      this.toggleEditing();
                    } else {
                      this.onSubmitForm();
                    }
                  }}
                >
                  {!this.state.editMode
                    ? "Редактировать"
                    : "Сохранить изменения"}
                </Button>
              </div>
              {this.state.editMode && (
                <div className="add-customer__progress-bar">
                  <FormProgress progress={this.state.formProgress} />
                </div>
              )}
              {this.state.editMode && (
                <div className="add-customer__button-wrap">
                  <Button
                    type="primary"
                    htmlType="button"
                    size="large"
                    className="add-customer__cancel"
                    style={{
                      width: "100%",
                      borderColor: "#F5222D",
                      color: "#F5222D"
                    }}
                    ghost
                    onClick={() => {
                      showConfirmAbortEdit({
                        onOk: () => {
                          this.toggleEditing();
                        }
                      });
                    }}
                  >
                    Отмена
                  </Button>
                </div>
              )}
              {!this.state.editMode && (
                <div className="add-customer__button-wrap">
                  <Button
                    type="primary"
                    htmlType="button"
                    size="large"
                    className="add-customer__cancel"
                    style={{
                      width: "100%"
                    }}
                    ghost
                    onClick={() => {
                      this.props.history.push("/customers/");
                    }}
                  >
                    Назад
                  </Button>
                </div>
              )}
              {/* Подготовил кнопки для будущего функционала блокировки и архивирования заказчика */}
              {/*{!this.state.editMode && (*/}
              {/*  <>*/}
              {/*    <div className="add-customer__button-wrap">*/}
              {/*      <Button*/}
              {/*        type="primary"*/}
              {/*        htmlType="button"*/}
              {/*        size="large"*/}
              {/*        className="add-customer__cancel"*/}
              {/*        style={{*/}
              {/*          width: "100%",*/}
              {/*          borderColor: "#F5222D",*/}
              {/*          color: "#F5222D"*/}
              {/*        }}*/}
              {/*        ghost*/}
              {/*        onClick={() => {*/}
              {/*          showConfirmAbortEdit({*/}
              {/*            onOk: () => {*/}
              {/*              this.toggleEditing();*/}
              {/*            }*/}
              {/*          });*/}
              {/*        }}*/}
              {/*      >*/}
              {/*        Заблокировать*/}
              {/*      </Button>*/}
              {/*    </div>*/}
              {/*    <div className="add-customer__button-wrap">*/}
              {/*      <Button*/}
              {/*        type="primary"*/}
              {/*        htmlType="button"*/}
              {/*        size="large"*/}
              {/*        className="add-customer__cancel"*/}
              {/*        style={{*/}
              {/*          width: "100%",*/}
              {/*          borderColor: "#F5222D",*/}
              {/*          color: "#F5222D"*/}
              {/*        }}*/}
              {/*        ghost*/}
              {/*        onClick={() => {*/}
              {/*          showConfirmAbortEdit({*/}
              {/*            onOk: () => {*/}
              {/*              this.toggleEditing();*/}
              {/*            }*/}
              {/*          });*/}
              {/*        }}*/}
              {/*      >*/}
              {/*        Архивировать*/}
              {/*      </Button>*/}
              {/*    </div>*/}
              {/*  </>*/}
              {/*)}*/}
            </Affix>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect(
  state => ({
    errors: state.Customers.customerCard.errors,
    customerData: state.Customers.customerCard.customer,
    updated: state.Customers.customerCard.updated
  }),
  {
    setCaption,
    getCustomer,
    editCustomer,
    dadataClearSelected
  }
)(CustomerCard);
